import DataTablePage from 'components/DataTablePage';
import MDButton from 'components/MDButton';
import { Navigate, useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogActions } from '@mui/material';
import { Can } from 'context';
import { useState } from 'react';
import brandColumnData from 'data/brandColumnData';
import { deleteBrand, getBrands } from 'services/brands';
import usePersistedFilters from 'hooks/usePersistedFilters';

function BrandManagement() {
  const navigate = useNavigate();
  const { setEntityFiltersForNavigation } = usePersistedFilters();
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [deleteBrandId, setDeleteBrandId] = useState('');
  const [filters, setFilters] = useState('');

  const handleViewDashboard = (brand) => {
    setEntityFiltersForNavigation({
      clientIds: brand.client?.id ? [brand.client.id] : [],
      clientNames: brand.client?.name ? [brand.client.name] : [],
      operatorIds: brand.operator?.id ? [brand.operator.id] : [],
      operatorNames: brand.operator?.name ? [brand.operator.name] : [],
      brandIds: [brand.id],
      brandNames: [brand.name]
    });
    navigate('/dashboard');
  };

  return (
    <>
      <Can I='read' a='brand'>
        <DataTablePage
          title='Brand Management'
          createButton={
            <Can I='create' a='brand'>
              <MDButton variant='contained' color='info' onClick={() => navigate('/brand-management/new-brand')}>
                Add Brand
              </MDButton>
            </Can>
          }
          canSearch
          canFilter
          fetchData={getBrands}
          queryKey='brands'
          columnData={brandColumnData}
          object={'brand'}
          onDelete={(id) => {
            setDeleteBrandId(id);
            handleOpenModal();
          }}
          onView={handleViewDashboard}
          filters={filters}
        />
        <Dialog
          open={showModal}
          onClose={handleCloseModal}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'Are you sure you want to delete this brand?'}</DialogTitle>
          <DialogActions>
            <MDButton
              onClick={async () => {
                await deleteBrand(deleteBrandId);
                handleCloseModal();
                setFilters(filters.length ? '' : 'd');
              }}
            >
              Yes
            </MDButton>
            <MDButton onClick={handleCloseModal}>No</MDButton>
          </DialogActions>
        </Dialog>
      </Can>
      <Can not I='read' a='brand'>
        <Navigate to='/dashboard' replace />
      </Can>
    </>
  );
}

export default BrandManagement;
